import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import * as validate from 'utils/validate';

import pxToRem from 'styles/pxToRem';

import { accountResetPassword } from 'redux/modules/account';

const styles = theme => ({
  grid: {
    marginTop: 15,
    '&:first-child': {
      marginTop: 0,
    },
  },
  typographyTitle: {
    textTransform: 'uppercase',
    paddingBottom: 14,
    marginBottom: 24,
    marginTop: 24,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  typographyText: {
    fontSize: pxToRem(13),
    margin: '0 0 15px',
    [theme.breakpoints.up('sm')]: {
      margin: '0 60px 15px',
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.pristine) {
    throw new SubmissionError({
      _error: 'Nothing to submit',
    });
  }
  return new Promise((resolve, reject) => {
    dispatch(accountResetPassword({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const ResetPasswordEmailForm = ({ className, handleSubmit, error, classes }) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Typography
      className={classes.typographyTitle}
      color="secondary"
      align="center"
    >
      Reset your password
    </Typography>
    <Typography
      className={classes.typographyText}
      align="center"
    >
      Please, enter your email address & we’ll get you back on track
    </Typography>
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Email"
          name="Email"
          label="Email"
          placeholder="Enter Email"
          component={TextField}
          validate={[validate.required, validate.email]}
          size="lg"
          type="email"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

ResetPasswordEmailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    typographyText: PropTypes.string.isRequired,
  }).isRequired,
};

ResetPasswordEmailForm.defaultProps = {
  error: null,
  className: '',
};

export default reduxForm({
  onSubmit,
})(withStyles(styles)(ResetPasswordEmailForm));



// WEBPACK FOOTER //
// ./src/components/account/ResetPasswordEmail/ResetPasswordEmailForm.js